module.exports = __webpack_public_path__ + "static/media/logo_insightmonk.fc7a545b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Navbar/logo_insightmonk.png
// module id = 957
// module chunks = 0